import React, { useCallback, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { Box, LinearProgress, Stack, Typography } from '@mui/material';

import useNotification from '../../../../core/hooks/use_notification';
import { getPodAction, getPodState } from '../../../../features/pod/get_pod';
import { ROUTE_PODS } from '../../../../core/constants';
import { getBusinessDataNotificationData, getPodNotificationData } from '../../../../core/utils/notification_utils';
import { getBusinessDataAction, getBusinessDataState } from '../../../../features/store/get_business_data';
import BusinessDataList from './data_list';
import SellThroughChart from './sell_through_chart';
import PageHeader from '../../../common/page_header';

const PodSalesDistributionPage = () => {
    const dispatch = useDispatch();
    const { showErrorMessage } = useNotification();
    const navigate = useNavigate();
    const location = useLocation();
    const { podId } = useParams();

    const getPod = useSelector(getPodState);
    const getBusinessData = useSelector(getBusinessDataState);

    const refreshList = useCallback(() => {
        dispatch(getBusinessDataAction({ podId }))
            .then(response => showErrorMessage(getBusinessDataNotificationData(response)));
    }, [dispatch, podId, showErrorMessage]);

    useEffect(() => {
        dispatch(getPodAction({ id: podId }))
            .then(response => showErrorMessage(getPodNotificationData(response)));
        refreshList();
    }, [dispatch, podId, refreshList, showErrorMessage]);

    return (
        <Box sx={ { display: 'flex', flexDirection: 'column', flexGrow: 1, gap: 3 } }>
            <PageHeader
                title="Rozkład sprzedaży"
                showBack={ true }
                onBack={ () => location.key !== 'default' ? navigate(-1) : navigate(ROUTE_PODS) }
                titleAdornment={
                    <Stack direction="row" alignItems="center" spacing={ 1 } sx={ { ml: 2 } }>
                        <Typography variant="body1" sx={ { fontWeight: 600 } }>
                            { getPod?.data?.name }
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                            • { getPod?.data?.indoorPartner?.name } • { getPod?.data?.address } ({ getPod?.data?.locationType })
                        </Typography>
                    </Stack>
                }
            />

            {
                getBusinessData?.loading &&
                <Box width="100%">
                    <LinearProgress/>
                </Box>
            }

            {
                getBusinessData?.data &&
                <Box sx={ { display: 'flex', flexDirection: 'column', flexGrow: 1, gap: 3 } }>
                    <SellThroughChart businessData={ getBusinessData?.data }/>
                    <BusinessDataList
                        pod={ getPod?.data }
                        refreshList={ refreshList }
                    />
                </Box>
            }
        </Box>
    );
};

export default PodSalesDistributionPage;